import axios from 'axios';
import _kebabCase from 'lodash/kebabCase';
import { XMLParser } from 'fast-xml-parser';
import { CONFIG } from '../config/config';

export const url = function (path) {
  return CONFIG.base_url + path;
};

export const remember = async function (url) {
  if (typeof url === undefined) {
    throw new Error('a url must be provided to "remember"');
  }

  const urlParts = url.split('?');
  const slug = urlParts
    .map(function (segment) {
      return segment
        .match(/[rstlncdmaeiou0-9]/gi)
        .sort()
        .join('')
        .slice(-25);
    })
    .join('');

  try {
    const { data } = await axios.get(url);
    return data;
  } catch (e) {
    console.error('error getting data', e);
  }
};

// This has an identical signature to S3.listObjectsV2 from the AWS SDK
export const S3_listObjectsV2 = function (listObjectsParams, callback) {
  const mapped_params = {};
  for (const i in listObjectsParams) {
    mapped_params[_kebabCase(i)] = listObjectsParams[i];
  }
  delete mapped_params.bucket;

  const s3_api_url = 'https://' + listObjectsParams.Bucket + '.s3.amazonaws.com/?list-type=2';
  axios({
    url: s3_api_url,
    method: 'get',
    responseType: 'text',
    params: mapped_params,
  }).then((response) => {
    const xmlParser = new XMLParser();
    const { ListBucketResult } = xmlParser.parse(response.data);
    callback(null, ListBucketResult);
  });
};

export const cachedPromise = function (slug, minutes = 10, _promise) {
  if (typeof arguments[1] === 'object') {
    _promise = arguments[1];
    minutes = null;
  }

  return new Promise(function (resolve, reject) {
    const returnPromise = new Promise(_promise);
    returnPromise.then(function (data) {
      resolve(data);
    });
  });
};

export const validateEmail = function (email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};
